import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Btn1 from '../componets/common/btn1';

import './login.css';
import logoImage from '../asserts/l.png';
import Preloader from '../componets/layout/preloader';

const Login = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [loginError, setLoginError] = useState('');

    const handleLogin = () => {
        const correctEmail = 'raia@gmail.com';
        const correctPassword = '123';

        let hasError = false;

        if (email !== correctEmail) {
            setEmailError(true);
            hasError = true;
        } else {
            setEmailError(false);
        }

        if (password !== correctPassword) {
            setPasswordError(true);
            hasError = true;
        } else {
            setPasswordError(false);
        }

        if (hasError) {
            setLoginError('Wrong email or password');
            return;
        }

        setLoginError('');
        navigate('/home');
    };

    return (
        <>
            <Preloader />
            <div className="login-page">
                <div className="login-bg-glow login-bg-glow--left"></div>
                <div className="login-bg-glow login-bg-glow--right"></div>

                <div className="login-wrapper">
                    <div className="login-header">
                        <div className="login-logo-wrap">
                            <img src={logoImage} alt="FoxEvents Logo" className="login-logo-img" />
                        </div>
                        <h1 className="login-title">FoxEvents Admin</h1>
                        <p className="login-subtitle">Sign in to manage your platform</p>
                    </div>

                    <div className="login-card">
                        <div className="login-field">
                            <label className="login-label">Email Address</label>
                            <div className={`login-input-wrap ${emailError ? 'input-error' : ''}`}>
                                <svg className="login-input-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
                                    <path d="M2 7L10 12L18 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                </svg>
                                <input
                                    type="email"
                                    className="login-input"
                                    placeholder="admin@eventhub.com"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setEmailError(false);
                                        setLoginError('');
                                    }}
                                />
                            </div>
                        </div>

                        <div className="login-field">
                            <label className="login-label">Password</label>
                            <div className={`login-input-wrap ${passwordError ? 'input-error' : ''}`}>
                                <svg className="login-input-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="4" y="9" width="12" height="9" rx="2" stroke="currentColor" strokeWidth="1.5" />
                                    <path d="M7 9V6a3 3 0 016 0v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                </svg>
                                <input
                                    type="password"
                                    className="login-input"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        setPasswordError(false);
                                        setLoginError('');
                                    }}
                                />
                                <button className="login-eye-btn" type="button">
                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 10s3-6 8-6 8 6 8 6-3 6-8 6-8-6-8-6z" stroke="currentColor" strokeWidth="1.5" />
                                        <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5" />
                                        <path d="M3 3l14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className="login-row">
                            <label className="login-remember">
                                <input
                                    type="checkbox"
                                    className="login-checkbox"
                                />
                                <span className="login-checkbox-custom"></span>
                                <span className="login-remember-text">Remember me</span>
                            </label>
                            <p className="login-forgot">Forgot password?</p>
                        </div>

                        {loginError && <p className="login-error-text">{loginError}</p>}

                        <div onClick={handleLogin} className="no-underline-link">
                            <Btn1 b='btn1' btntt='Sign in' />
                        </div>

                        <div className="login-divider"></div>

                        <p className="login-help">
                            Need help?{' '}
                            <span className="login-support-link">support@eventhub.com</span>
                        </p>
                    </div>

                    <p className="login-footer">© 2026 FoxEvents. All rights reserved.</p>
                </div>

                <button className="login-help-btn">
                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M10 14v-1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M7.5 7.5a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </button>
            </div>
        </>
    );
};

export default Login;